import { combineReducers } from 'redux';

import commonReducer from './common/commonReducer';
import shopListReducer from './shopList/shopListReducer';
import shopReducer from './shopList/shopReducer';
import scheduleReducer from './schedule/index';
import visitorRegisterReducer from './visitorRegister/visitorRegisterReducer';
import visitorRegisterConfirmReducer from './visitorRegister/visitorRegisterConfirmReducer';
import simpleAuthReducer from './simpleAuth/simpleAuthReducer';
import reserveHistoryReducer from './reserveHistory';

// 他のReducerを組み立てる
const rootReducers = combineReducers({
  common: commonReducer,
  shopList: shopListReducer,
  shop: shopReducer,
  schedule: scheduleReducer,
  visitorRegister: visitorRegisterReducer,
  visitorRegisterConfirm: visitorRegisterConfirmReducer,
  simpleAuth: simpleAuthReducer,
  reserveHistory: reserveHistoryReducer,
  registerComplete: visitorRegisterConfirmReducer,
});

// Reducerをtype設定する
export type RootState = ReturnType<typeof rootReducers>;

export default rootReducers;
